import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFormChanged_Type,
  HookFormValidate_Type,
  HookTableDialogGetTitleRender_Type,
  HookTableDialogGetTitleRender_ReturnType,
  HookTableAfterSave_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import { FieldCurrentVal } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

import { SetSettingsForm } from "./helpers"

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (value) => {
  if (value.field.fieldKey === "PrtOfferingCadUserField") {
    let val = parseInt(FieldCurrentVal(value.field))
    if (isNaN(val) || !(val > 0 && val < 1000)) {
      value.validationsAdd("QUTOfferingOfferingCadUserFieldRange")
    }
  } else if (value.field.fieldKey === "U_PrtOfferingCadVal") {
    value.validatorUse("MinLength", { val: 2 })
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = (value) => {
  let changedField = value.changedField
  if (
    changedField.isValid &&
    changedField.field.fieldKey === "U_PrtOfferingCadAttr"
  ) {
    SetSettingsForm(value.formState)
  }
}

const HookField_U_PrtOfferingCadAttr_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let res: HookFieldGetList_ReturnType = {
    data: {
      "EDV-Code": { CadAttr: "EDV-Code" },
      Bemerkung: { CadAttr: "Bemerkung" },
      Benutzerdefiniert: { CadAttr: "Benutzerdefiniert" },
    },
    lookupDef: {
      CadAttr: { type: "text", translationKey: "QUTOfferingOfferingCadAttr" },
    },
  }
  return res
}

const HookTableAfterSave: SYSAction<HookTableAfterSave_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  // rearrange table result into user setting

  if (value.def.id === "QUTOfferingSettings") {
    let data = value.res.data[0]
    let userSettings = state.app.global.GEN.user
    userSettings.offeringCadAttr = data["U_PrtOfferingCadAttr"]
    userSettings.offeringCadUserField = data["PrtOfferingCadUserField"]
    userSettings.offeringCadVal = data["U_PrtOfferingCadVal"]
  }
}

const HookTableDialogGetTitleRender: SYSAction<
  HookTableDialogGetTitleRender_Type,
  HookTableDialogGetTitleRender_ReturnType
> = (value) => {
  if (value.actionKey === "SYSTableRowFnEdit") {
    return T("QUTOfferingOfferingSettings")
  }
}

export let hooks = {
  HookFormValidate,
  HookFormChanged,
  HookField_U_PrtOfferingCadAttr_GetList,
  HookTableAfterSave,
  HookTableDialogGetTitleRender,
}
